export default __webpack_public_path__ + "static/media/activity_icon.aeb45871.svg";